import config from "config/config";
import { DeliveryFile } from "models/DeliveryFile";
import { ArchiveItem } from "models/ArchiveItem";
import { DeliveryUploadFile } from "views/delivery/containers/DocumentDeliveryUpload";
import { apiRequest } from "./apiInterceptor";
import { UploadErrorContext } from "common/apiErrorHandling/customErrorHandlers";

export class DeliveryAPI {
  static async fetchUploadedFiles(customerId: string) {
    const response = await apiRequest
      .get(config.api.file.get + customerId)
      .send({
        CustomerId: customerId
      });

    const result = JSON.parse(response.text);

    return result.items;
  }

  static async setFileAsHandled(
    itemToHandle: DeliveryFile,
    customerId: string
  ) {
    const response = await apiRequest.post(config.api.file.setHandled()).send({
      CustomerId: customerId,
      FileIds: [itemToHandle.id]
    });

    return response;
  }

  static async moveToArchive(
    item: ArchiveItem | DeliveryFile,
    customerId: string,
    path: string,
    name: string
  ) {
    const response = await apiRequest
      .post(config.api.file.moveToArchive(customerId, item.id))
      .send({
        customerId,
        path,
        fileId: item.id,
        name
      });

    return response;
  }

  static async sendFile(
    file: DeliveryUploadFile,
    customerId: string,
    context: UploadErrorContext
  ) {
    const formData = new FormData();
    formData.append("File", file.file);
    formData.append("Category", file.meta.category || "Okategoriserad");
    formData.append("Comment", file.meta.comment || "");

    const request = apiRequest.post(config.api.file.postV2(customerId));

    (request as any).errorHandlerContext = context;

    const response = await request.send(formData);
    const newItem = JSON.parse(response.text) as DeliveryFile;
    return newItem;
  }

  static async deleteDocuments(customerId: string, fileId: string) {
    const response = await apiRequest.delete(
      config.api.externalUserFiles.deleteFile(customerId, fileId)
    );

    return response;
  }
}
